import { Component } from '@angular/core';

@Component({
  selector: 'app-get-start',
  templateUrl: './get-start.component.html',
  styleUrls: ['./get-start.component.css']
})
export class GetStartComponent {

constructor(){
  this.scrollToTop();
}
  scrollToTop() {
    document
      .getElementById('maincontent')
      ?.scrollIntoView({ behavior: 'smooth'});
  }
}
